import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
    fetchReturnPolicy,
    createReturnPolicy,
    viewReturnPolicy,
    deleteReturnPolicy,
    updateReturnPolicy,
    fetchProductList,
} from "@/services/returnPolicy";
@Module({
    namespaced: true,
})
export default class returnPolicy extends VuexModule {
    // state
    returnPolicy = [];
    returnPolicyDetails = {};
    //action
    @Action
    public async fetchReturnPolicyAction() {
        try {
            const data = await fetchReturnPolicy();
            this.context.commit("SET_RETURN_POLICY", data.data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchProductListAction() {
        try {
            const data = await fetchProductList();
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async createReturnPolicy(payload) {
        try {
            return await createReturnPolicy(payload);
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async deleteReturnPolicyAction(payload) {
        try {
            return await deleteReturnPolicy(payload);
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async updateReturnPolicy(payload) {
        try {
            return await updateReturnPolicy(payload);
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async viewReturnPolicy(payload) {
        try {
            const data = await viewReturnPolicy(payload);
            this.context.commit("SET_RETURN_POLICY_BY_ID", data.data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }
    //mutation
    @Mutation
    public SET_RETURN_POLICY(data: any) {
        this.returnPolicy = data;
    }
    @Mutation
    public SET_RETURN_POLICY_BY_ID(data: any) {
        this.returnPolicyDetails = data;
    }
    //getters
}
